import { CollectionEntityResponse, flattenEntity, OperationMethod, processFetchOperation } from '../api';
import { PreviousClaimSummary } from '../../domain/entities/PreviousClaimSummary';

type ClaimInfoDto = {
    key: string;
    createdAt: string;
    status: string;
    claimSummary?: string | null;
};

/**
 * Reuses GET /v1/claim-informations — the same endpoint the incidents page already consumes —
 * and projects just the fields the clinical-history "previous claims" panel needs. Sorted by
 * createdAt desc (newest first).
 */
export const PreviousClaimSummariesNomaRepository = {
    findByPolicyIdentifier: (policyIdentifier: string): Promise<PreviousClaimSummary[]> => {
        return processFetchOperation('/v1/claim-informations', OperationMethod.GET, {
            params: { policyIdentifier },
        }).then((dto: CollectionEntityResponse<ClaimInfoDto>) =>
            dto.data
                .map((it) => flattenEntity(it, []))
                .map((it) => ({
                    claimRequestKey: it.key,
                    createdAt: new Date(it.createdAt),
                    status: it.status,
                    summary: it.claimSummary ?? undefined,
                }))
                .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime())
        );
    },
};
